import { useState } from 'react';
import { Link } from 'react-router-dom';
import Panel from '~/components/Panel';
import AssignFinancialCoordinatorDrawer from '~/components/FundRequests/drawers/AssignFinancialCoordinatorDrawer';
import { FinancialCoordinatorOption } from '~/types/fundrequests';

interface Props {
    fc: FinancialCoordinatorOption | null;
    financial_coordinators: FinancialCoordinatorOption[];
    handleSaveFinancialCoordinator: (fc: FinancialCoordinatorOption) => void;
    saving: boolean;
}
const FcBlock: React.FC<Props> = ({
    fc,
    financial_coordinators,
    handleSaveFinancialCoordinator,
    saving,
}) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const bgColor = fc
        ? 'bg-[#e6f7f8] border-[#e6f7f8]'
        : 'bg-[#fdeaeb] border-[#fdeaeb]';

    return (
        <>
            <Panel addClasses={`${bgColor} flex-1`}>
                <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
                    Financial Coordinator
                </h2>
                <div
                    className={`text-[38px]/[44px] ${
                        fc ? 'font-bold' : ''
                    } text-[#131212] ${fc ? '' : 'italic'}`}
                >
                    {fc ? `${fc.first_name} ${fc.last_name}` : 'None Assigned'}
                </div>
                <div className='text-[16px]/[24px]'>
                    {!fc && (
                        <button
                            className='mr-[16px] text-[#F02D3A]'
                            onClick={() => setIsDrawerOpen(true)}
                        >
                            Assign
                        </button>
                    )}
                    {/* {fc && (
                        <Link className='mr-[16px] text-[#00AEB3]' to='#'>
                            Message
                        </Link>
                    )} */}
                    {fc && (
                        <button
                            className='text-[#00AEB3]'
                            onClick={() => setIsDrawerOpen(true)}
                        >
                            Reassign
                        </button>
                    )}
                </div>
            </Panel>
            <AssignFinancialCoordinatorDrawer
                isOpen={isDrawerOpen}
                setIsOpen={(open) => {
                    setIsDrawerOpen(open);
                }}
                financial_coordinators={financial_coordinators}
                handleSaveFinancialCoordinator={handleSaveFinancialCoordinator}
                saving={saving}
            />
        </>
    );
};

export default FcBlock;
